import { render, staticRenderFns } from "./FoodFilters.vue?vue&type=template&id=8c14ff60"
import script from "./FoodFilters.vue?vue&type=script&lang=js"
export * from "./FoodFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports